<template>
  <div class="comp-agency-tree">
    <el-popover
      :popper-class="popperClass"
      v-model="visible"
      ref="popover"
      placement="bottom-start"
      :visible-arrow="false"
      :width="width"
      @show="handleShow"
      @hide="handleHideMore"
      trigger="click">
      <AgencyTreeCore
        v-show="!showMore"
        v-bind="$attrs"
        v-on="$listeners"
        :treeData="coreData"
        :isCRMUser="isCRMUser"
        :filter-node-method="filterNodeMethod"
        :checkable="checkable"
        ref="treeCore"
        @showMore="handleShowMore"
        @checkAgencyLeaves="checkAgencyLeaves"
        @nodeClick="handleNodeClick"></AgencyTreeCore>
      <AgencyTreeDetail
        v-show="showMore"
        v-bind="$attrs"
        v-on="$listeners"
        :treeData="detailData"
        :isCRMUser="isCRMUser"
        :checkable="checkable"
        ref="treeDetail"
        @confirm="handleConfirm"
        @close="handleClose"></AgencyTreeDetail>
    </el-popover>
    <el-input
      placeholder="请选择门店"
      v-model="inputValue"
      suffix-icon="el-icon-caret-bottom"
      readonly
      v-popover:popover
      class="trigger-input"></el-input>
  </div>
</template>

<script>
  import AgencyTreeCore from './AgencyTreeCore';
  import AgencyTreeDetail from './AgencyTreeDetail';

  import {findChild, flatern, getDataByHotelId, init} from './agencyUtils';

  export default {
    props: {
      'dataSource': {
        type: Array,
        default: []
      },
      isCRMUser: {
        type: Boolean,
        default: true
      },
      checkable: {
        type: Boolean,
        default: true
      },
      onlyHotel: {
        type: Boolean,
        default: true
      }
    },
    name: 'popover',
    components: {
      AgencyTreeCore,
      AgencyTreeDetail
    },
    inheritAttrs: false,
    data () {
      return {
        popperClass: 'comp-agency-tree-popover',
        visible: false,
        inputValue: '',
        width: 250,
        offset: 0,
        showMore: false,
      };
    },
    created () {
      const orgTree = this.dataSource.map((item) => {
        return Object.assign({}, item);
      });
      let root = this.isCRMUser ? orgTree[0] : orgTree[orgTree.length - 1];
      init();
      root.children = findChild(orgTree, root.id, this.onlyHotel);
      this.coreData = flatern(root, 0, -1);
      this.detailData = JSON.parse(JSON.stringify(this.coreData));
    },
    methods: {
      handleShowMore () {
        this.width = 480;
        this.popperClass = 'comp-agency-tree-popover customOffset';
        this.showMore = true;
        this.$nextTick(() => {
          const ids = [];
          this.coreData.forEach((item) => {
            if (item.checkStatus.checked === 2/* && item.type === 3*/) {
              ids.push(item.id);
            }
          });
          this.$refs.treeDetail.show(ids);
        });
      },
      filterNodeMethod (item, filterText) {
        return item.name.indexOf(filterText) !== -1;
      },
      //全选
      selectAll () {
        if (this.checkable) {
          this.$refs.treeCore.selectAll();
        } else {
          this.$refs.treeCore.setAgency([]);
        }
      },
      setAgency (agencies) {
        agencies = agencies || [];
        this.$refs.treeCore.setAgency(agencies);
      },
      setAgencyByHotelId (hotelId) {
        let agencies = this.getIdByHotelId(hotelId) || [];
        this.$refs.treeCore.setAgency(agencies);
      },
      getIdByHotelId (hotelIds) {
        const ids = [];
        hotelIds.forEach((hotelId) => {
          ids.push(getDataByHotelId(this.coreData, hotelId).id);
        });
        return ids;
      },
      handleNodeClick (item) {
        if (!this.checkable) {
          // 单选不能选择非门店的节点
          if (item.type !== 3) {
            // 选择非门店，直接return不emit事件
            return;
          }
          // 选择完成，关闭选择框
          this.visible = false;
        }
        this.inputValue = item.name;
        this.$emit('checkAgencyLeaves', [item]);
      },
      checkAgencyLeaves (selectedAgencies) {
        let checkedNum = selectedAgencies.length;
        switch (checkedNum) {
          case 0:
            this.inputValue = '';
            break;
          case 1:
            this.inputValue = selectedAgencies[0].name;
            break;
          default:
            this.inputValue = `已选择 ${checkedNum} 家门店`;
        }
        this.$emit('checkAgencyLeaves', selectedAgencies);
      },
      handleShow () {
        this.$nextTick(() => {
          this.$refs.treeCore.clearFilter();
          this.$refs.treeCore.update();
        });
      },
      handleHideMore () {
        this.width = 250;
        this.popperClass = 'comp-agency-tree-popover';
        this.showMore = false;
      },
      handleConfirm (ids) {
        this.width = 250;
        this.popperClass = 'comp-agency-tree-popover';
        this.showMore = false;
        this.visible = false;
        this.$nextTick(() => {
          this.setAgency(ids);
        });
      },
      handleClose (ids) {
        this.width = 250;
        this.popperClass = 'comp-agency-tree-popover';
        this.showMore = false;
      }
    }
  };
</script>

<style lang="less">
  .comp-agency-tree {
    .trigger-input input {
      width: 250px !important;
      cursor: pointer;
    }
  }

  .comp-agency-tree-popover.customOffset {
    margin-left: -230px !important;
  }

  .comp-agency-tree-popover {
    overflow-y: hidden;
    margin-top: 5px !important;
    padding: 0 !important;
    box-shadow: 0 0 0 0 rgba(6, 44, 82, 0.10), 0 2px 16px 0 rgba(33, 43, 54, 0.08) !important;
    .el-tree {
      margin-top: 5px;
      overflow-y: auto;
      position: relative;
      .disabled-text {
        color: #909399;
        cursor: not-allowed;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// AgencyTree.vue?408048cd